import type { CheckboxStylesType } from '@material-tailwind/react';
const styles: CheckboxStylesType = {
  defaultProps: {
    color: 'blue',
    ripple: false,
    disabled: false,
  },
  valid: {
    colors: ['blue', 'black'],
  },
  styles: {
    base: {
      container: {
        p: 'p-0',
      },
      input: {
        borderColor: 'border-blue-500 disabled:border-slate-500',
        transition: '',
        before: {
          bg: 'before:bg-transparent',
          transition: '',
        },
      },
      label: {
        m: 'ml-2.5',
      },
      icon: {
        color: 'text-blue-500 peer-disabled:text-slate-500',
        left: 'left-[2.1px]',
      },
    },
    colors: {
      blue: {
        background: 'white',
        border: 'border-blue-500',
        before: 'checked:before:bg-blue-500',
      },
      black: {
        border: 'border-black',
        before: 'checked:before:bg-black',
        icon: 'text-black',
      },
    },
  },
};

export default styles;
